export default __webpack_public_path__ + "static/pistol-cc66c8c32e3d786e7d154c0ec0bc6b76.png";